import CheckIn from './CheckIn';

export default CheckIn;


// WEBPACK FOOTER //
// ./src/containers/site-visits/components/checkIn/index.js